import {TvShopEntertainmentPack} from '../model/tv-shop-entertainment-pack';
import {OmapiIdsUtils} from '../shared/utils/omapi-ids/omapi-ids-utils';
import {
  TvShopEntertainmentPackGroupIds
} from '../constants/tv-shop-entertainment-pack/tv-shop-entertainment-pack-group.constants';

export class StreamingServicesUtil {
  public static getStandAloneStreamingServices(streamingServices: TvShopEntertainmentPack[]): TvShopEntertainmentPack[] {
    const streamingStandalone = streamingServices.filter((streamingService: TvShopEntertainmentPack) => {
      return streamingService.isStreamingStandaloneProduct;
    });
    if (streamingStandalone) {
      return streamingStandalone;
    }
    return [];
  }

  public static getStreamingBundles(streamingServices: TvShopEntertainmentPack[]): TvShopEntertainmentPack[] {
    const streamingBundles = streamingServices.filter((streamingService: TvShopEntertainmentPack) => {
      return streamingService.isStreamingBundle;
    });
    if (streamingBundles) {
      return streamingBundles.sort((a, b) => a.omapiId > b.omapiId ? 1 : -1);
    }
    return [];
  }

  public static getStandAloneNetflix(streamingServices: TvShopEntertainmentPack[]): TvShopEntertainmentPack {
    return streamingServices.find(ss => ss.omapiId === OmapiIdsUtils.NETFLIX_BASIC_ID);
  }

  public static getStandAloneDisneyPlus(streamingServices: TvShopEntertainmentPack[]): TvShopEntertainmentPack {
    return streamingServices.find(ss => ss.omapiId === OmapiIdsUtils.DISNEY_PLUS_ID);
  }


  public static getNetflixStandaloneGroup(streamingServices: TvShopEntertainmentPack[]): TvShopEntertainmentPack {
    return streamingServices.find(ss => ss.omapiId === TvShopEntertainmentPackGroupIds.NETFLIX_STANDALONE);
  }
}
